import React from 'react';

import { InfoCard } from '@eika/card';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import AvtaleGiroItem from '../../components/AvtaleGiroItem/AvtaleGiroItem';
import AvtaleGiroItemSkeleton from '../../components/AvtaleGiroItem/AvtaleGiroItemSkeleton';
import { Content } from '../../components/shared/Content';
import { useAvtalegiro } from '../../fetchHooks/useAvtalegiro';
import type { PaymentAgreementId } from '../../generated-types';
import useTranslation from '../../hooks/useTranslation';
import AvtalgiroListError from './AvtalgiroListError';

import './AvtaleGiro.scss';

interface Props {
    selectAvtaleGiro: (id: PaymentAgreementId) => void;
}

const AvtaleGiroList: React.FC<Props> = ({ selectAvtaleGiro }: Props) => {
    const translated = useTranslation();

    const { data: avtalegiro, error, isLoading, refetch } = useAvtalegiro();

    const hasAvtaleGiro = avtalegiro && avtalegiro.length !== 0;
    if (isLoading) {
        return (
            <div className="avtalegiro_proposals_skeleton_wrapper">
                <h2 className="avtalegiro__proposals__title typography-h3">{translated.avtaleGiroAgreement.title}</h2>
                <AvtaleGiroItemSkeleton />
            </div>
        );
    }

    if (error) {
        return <AvtalgiroListError error={error} refetch={refetch} />;
    }

    if (!hasAvtaleGiro) {
        return (
            <Content>
                <InfoCard className="avtalegiro__no-avtalegiro" skipBackground>
                    <RichIcon type={RichIconTypes.FANGER_SOMMERFUGLER} />
                    <InfoCard.TitleH2>{translated.avtaleGiroAgreement.noAvtalegiro}</InfoCard.TitleH2>
                </InfoCard>
            </Content>
        );
    }

    return (
        <>
            <h2 className="avtalegiro__title typography-h3">{translated.avtaleGiroAgreement.title}</h2>
            <ul className="avtalegiro__list">
                {avtalegiro.map((avtaleGiro) => (
                    <AvtaleGiroItem
                        onClick={() => selectAvtaleGiro(avtaleGiro.id)}
                        key={avtaleGiro.id.toString()}
                        avtalegiro={avtaleGiro}
                    />
                ))}
            </ul>
        </>
    );
};

export default AvtaleGiroList;
